import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import auth from './auth.module'
import data from './data.module'
import flappy from './flappy.module'
import talk from './talk.module'

const store = createStore({
  modules: {
    auth,
    data,
    flappy,
    talk,
  },
  plugins: [
    createPersistedState({
      paths: ['auth', 'data']
    })
  ],
});

export default store;
